<template>
  <v-container fluid fill-height>
    <v-toolbar color="blue darken-1" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 150px; height: 70px;" alt>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md8>
        <v-card class="elevation-12">
          <v-toolbar dark color="blue darken-1">
            <v-toolbar-title>Complete Bidding Job</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap v-if="job">
              <v-flex xs12 sm12>
                <p>
                  <b>Job Title:</b>
                  {{job.title}}
                </p>
              </v-flex>
              <v-flex xs12 sm12>
                <p>
                  <b>Description:</b>                  
                  <div v-html="job.description"></div>
                </p>
              </v-flex>
              <v-flex xs12 sm12>
                <div>
                  <b>Expertise Category:</b>
                  {{job.category}}
                </div>
              </v-flex>
              <v-flex xs12 sm12>
                <h4>Timeframe: {{job.timeFrame}}</h4>
              </v-flex>
              <v-flex xs12 sm12>
                <v-btn color="red" dark @click="engageSonko">Bid Now</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PaymentsPage",
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["webUrl"])
  },
  data() {
    return {
      job: null,
      jobId: null
    };
  },
  watch: {
    "$route.params.id": {
      handler: "getJob",
      immediate: true
    }
  },
  methods: {
    getJob() {
      const id = this.$route.params.id;
      if (id !== undefined) {
        this.$store.dispatch("get", "/job/" + id).then(res => {
          this.job = res.job;
        });
      }
      if (this.user == undefined) {
        this.$router.push(`/login/expert/job?id=${id}`);
      }
    },
    engageSonko() {
      const data = {
        sonko: this.job.userId,
        jobId: this.job._id,
        userId: this.user._id
      };
      // send request
      this.loader = true;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/engagement", data })
        .then(res => {})
        .finally(() => {
          self.loader = false;
          self.dialog = true;
          self.$router.push("/expert/jobs");
        });
      // end
    }
  },
  created() {
    if (this.user.accountType == "sonko") {
      this.$router.push("/login/sonko/normal");
    }
  }
};
</script>



